import { render, staticRenderFns } from "./EditProjectModal.vue?vue&type=template&id=2b4ad699"
import script from "./EditProjectModal.vue?vue&type=script&lang=ts"
export * from "./EditProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./EditProjectModal.vue?vue&type=style&index=0&id=2b4ad699&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports